// extracted by mini-css-extract-plugin
module.exports = {"pdp_atc_aid_icon":"addToList_pdp_atc_aid_icon__qny9r","pdp_atl_background":"addToList_pdp_atl_background__K0QBe"};